import { render, staticRenderFns } from "./notActivityPirce.vue?vue&type=template&id=82636864&scoped=true"
import script from "./notActivityPirce.vue?vue&type=script&lang=js"
export * from "./notActivityPirce.vue?vue&type=script&lang=js"
import style0 from "./notActivityPirce.vue?vue&type=style&index=0&id=82636864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82636864",
  null
  
)

export default component.exports